<template>
    <div class="col-md-12">
        <form @submit.prevent="addService">

            <div class="">
                <div class="h2">Add new service</div>
                <div class="">

                    <div class="container-fluid bg-light py-3">
                        <div class="messages"></div>
                        <div class="controls">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <label for="name">
                                            <strong>Name</strong>
                                        </label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="service.name=='' && isSubmit? 'border-danger':''">
                                            <input type="text" autocomplete="none" required
                                                   class="form-control form-control border-0 py-0 shadow-none form-input"
                                                   placeholder="Service name"
                                                   id="name"
                                                   v-model="service.name">
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="description">
                                            <strong>Description</strong>
                                        </label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="service.description=='' && isSubmit? 'border-danger':''">
                                            <textarea required
                                                      class="form-control form-control border-0 py-0 shadow-none form-input"
                                                      v-model="service.description"
                                                      id="description"
                                                      placeholder="Service description"></textarea>
                                            <div class="help-block with-errors"></div>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label for="type">
                                            <strong>Type</strong>
                                        </label>
                                        <div
                                            class="d-flex align-items-center bg-white border rounded-lg div-focus border-2"
                                            :class="service.type=='' && isSubmit? 'border-danger':''">
                                            <select required class="form-control border-0 py-0 shadow-none pr-5"
                                                    id="type"
                                                    v-model="service.type">
                                                <option :value="type" v-for="(typeName, type) in types">{{ typeName }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="clearfix"></div>

                        <div class="row">
                            <div class="col-md-12">
                                <button type="submit" class="btn btn-primary" @click="validation()">Save</button>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <p class="text-muted"></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <a href="/products" title="Back" class="text-decoration-none">
            <button class="btn default btn-sm d-flex align-items-center">
                <span class="material-icons-outlined cursor-pointer text-primary">arrow_back</span>
                <span class="pl-1">Back</span>
            </button>
        </a>
    </div>
</template>

<script type="text/ecmascript-6">

export default {
    name: "ServiceCreate",
    props: {
        types: {type: Object, required: true},
    },
    data() {
        return {
            service: {
                price_type: 1
            },
            isSubmit: false
        }
    },
    methods: {
        validation() {
            this.isSubmit = true;
        },
        addService() {
            let uri = '/services';
            axios.post(uri, this.service).then((response) => {
                window.location.href = `/products`;
            }).catch(err => console.log(err))
        }
    }
}

</script>
